<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  props: {
    onCancelRoute: {
      default: '/agendamentos'
    }
  },
  computed: {
    ...mapState('fichaClinica', ['agendamento'])
  },
  mounted() {
    if (!this.agendamento.idAso) {
      this.$router.push({ path: `/atendimento-hibrido/${this.$route.params.idClinica}` })
    }
  }
}
</script>
